import { atom } from 'recoil';
import { Workspace } from '../types/files';

const workspaceState = atom<Workspace | null>({
  key: 'workspace/workspace',
  default: null,
  effects_UNSTABLE: [({ onSet }) => {
    onSet((newValue) => {
      if (localStorage.getItem('config.logger-setter'))
        console.log("SET", ['workspace/workspace', newValue]);
    });
  }],
});

export { workspaceState};
